import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["childButton", "list"]

  toggle() {
    if (this.element.classList.contains('open')) {
      this.hide()
    } else {
      this.show()
    }
  }

  show() {
    this.listTargets.forEach(target => target.style.display = 'block')
    this.childButtonTargets.forEach(target => target.classList.add('open'))
    this.element.classList.add('open')
  }

  hide() {
    this.listTargets.forEach(target => target.style.display = 'none')
    this.childButtonTargets.forEach(target => target.classList.remove('open'))
    this.element.classList.remove('open')
  }
}
